import { FC } from "react";

import { SecondaryOverlay } from "components/constants";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { MenuItem } from "mds/components/Menu";
import { SquareIconButton } from "mds/components/buttons/SquareIconButton";
import { PersonClassIcon } from "mds/icons";
import { useOverlayControls } from "utils/routing/hooks/use-overlay-controls";

export const UserPanelToggleButton: FC<{ isMobile?: boolean; isMenuItem?: boolean }> = ({
  isMobile = false,
  isMenuItem = false,
}) => {
  const { isSelected, togglePanel } = useOverlayControls(SecondaryOverlay.Users);

  if (isMenuItem) {
    return (
      <MenuItem
        eventName="Section Users - Toggle"
        eventProps={{ isOpened: !isSelected }}
        onClick={togglePanel}
      >
        <IconText iconStart={<PersonClassIcon />} text={t("content_sidebar.title.Users")} />
      </MenuItem>
    );
  }

  return (
    <SquareIconButton
      aria-label={t("content_sidebar.title.Users")}
      data-panel-trigger={SecondaryOverlay.Users}
      eventName="Section Users - Toggle"
      eventProps={{ isOpened: !isSelected }}
      isSelected={isSelected}
      kind="secondary"
      size={isMobile ? "xl" : "l"}
      onClick={togglePanel}
    >
      <PersonClassIcon />
    </SquareIconButton>
  );
};
